<main class="container">
    <section id="column1" npSetLayout [pageLayout]="PageLayout.Layout12">
        <div class="row">
            <div class="col col-12">
                <h1>bulk create primary user</h1>
            </div>
        </div>
    </section>
</main>
